import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const HoymaPage = (props: Props): JSX.Element => {
    return (
        <S_BMPage className={props.className}>
            <CustomMapPage
                mapId={'6dd7833d-e7c7-4919-a0c8-8f51b5a6d605'}
                mapProps={{
                    light: {
                        anchor: 'viewport',
                        color: 'white',
                        intensity: 0.15
                    }
                }}
            />
        </S_BMPage>
    );
};

const S_BMPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
